<template>
  <span v-if="item === undefined || item === null">
    Non esiste
  </span>
  <div v-else-if="checkType('style')">
    <v-select
      v-model="localItem"
      :items="Object.keys(configuration.globalConfig.styles.value)"
      chips
      multiple
    ></v-select>
  </div>
  <div v-else-if="checkType('object')">
    <div
      v-for="(el, index) in Object.keys(item)"
      v-bind:key="index"
      :style="{ 'padding-left': path.length * 10 + 'px' }"
    >
      <p v-if="info[el].type !== 'hidden'">{{ info[el].description }}:</p>
      <card
        :item="item[el]"
        :info="info[el]"
        :configuration="configuration"
        :path="[...path, el]"
        @mutate="$emit('mutate', $event)"
      ></card>
    </div>
  </div>
  <v-select
    v-else-if="checkType('font')"
    :items="['cursive', 'ultra', 'light', 'bold']"
    v-model="localItem"
  >
  </v-select>
  <v-select
    v-else-if="checkType('color')"
    :items="['primary', 'secondary', 'background', 'foreground']"
    v-model="localItem"
    class="ms-2"
  ></v-select>

  <v-switch
    v-else-if="checkType('boolean')"
    v-model="localItem"
    :label="item.title || item.name"
    inset
  ></v-switch>
  <v-text-field
    v-else-if="checkType('number') || checkType('string')"
    :label="info.description"
    v-model="localItem"
  ></v-text-field>
  <span v-else-if="checkType('hidden')"></span>
  <v-select
    v-else-if="checkType('method')"
    :items="['GET', 'POST', 'PUT', 'DELETE']"
    v-model="localItem"
  ></v-select>
  <span v-else>Controllo non gestito {{ item }}</span>
</template>

<script>
/* eslint-disable */
export default {
  name: "card",
  props: {
    item: null,
    info: null,
    configuration: Object,
    path: Array,
  },
  beforeMount() {
    this.tema = this.$store.state.totem.theme.themes[0];
    // console.log('INFO:', this.info)
  },
  data() {
    return { tema: {} };
  },
  computed: {
    localItem: {
      get() {
        return this.item;
      },
      set(value) {
        this.$emit("mutate", { value, path: this.path });
      },
    },
    getFromConfiguration() {
      let val = this.configuration;
      for (let i = 0; i < this.path.length; i++) {
        val = val[this.path[i]];
      }
      return val;
    },
  },
  methods: {
    checkType(type) {
      return this.info.type === type;
    },
  },
};
</script>
